export enum Constants {
  SET_TRENDS = '@trending/set_player',
}
